import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../../analytics/store/analyticsSlice";
import { MessageButtonMenu } from "./MessageButtonMenu";
import { CopyButton } from "../CopyButton";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { Snackbar } from "@mui/material";
import { feedbackService } from "../../services/feedbackService";
import { FeedbackModal } from "../FeedbackModal";

interface AgentMessageButtonMenuProps {
  messageId: string;
  conversationId: string;
  isVisible?: boolean;
}

export const AgentMessageButtonMenu: React.FC<AgentMessageButtonMenuProps> = ({
  messageId,
  conversationId,
  isVisible = true,
}) => {
  const dispatch = useDispatch();
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleGoodFeedback = async () => {
    await feedbackService.submitGoodFeedback(conversationId, messageId);
    dispatch(
      trackEvent({
        name: "agent_feedback_provided",
        params: { rating: "good" },
      })
    );
    setSnackbarMessage("Thank you for your feedback!");
    setSnackbarOpen(true);
  };

  const handleBadFeedback = () => {
    setIsFeedbackModalOpen(true);
  };

  const handleSubmitBadFeedback = async (details: string) => {
    await feedbackService.submitBadFeedback(conversationId, messageId, details);
    dispatch(
      trackEvent({ name: "agent_feedback_provided", params: { rating: "bad" } })
    );
    setSnackbarMessage(
      "Thank you for your feedback. We'll work on improving this."
    );
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      <MessageButtonMenu
        isVisible={isVisible}
        buttons={[
          {
            icon: <CopyButton elementId={messageId} />,
            tooltip: "Copy text",
            onClick: () => {}, // Click is handled by CopyButton itself
          },
          {
            icon: <ThumbUpOutlinedIcon fontSize="small" />,
            tooltip: "This was helpful",
            onClick: handleGoodFeedback,
          },
          {
            icon: <ThumbDownOutlinedIcon fontSize="small" />,
            tooltip: "This needs improvement",
            onClick: handleBadFeedback,
          },
        ]}
      />
      <FeedbackModal
        open={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
        onSubmit={handleSubmitBadFeedback}
      />
    </>
  );
};
